<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Configurable snackbar demo" />
    <vc-layout :spacing="8">
      <vc-col :span="4" md6 sm12 xs24>
        <h4 :class="radioHeading">Vertical Position</h4>
        <vc-radio-group
          name="verticals"
          :color="radiosColor"
          v-model="vertical">
          <vc-radio v-for="(vertical, index) in verticals" :value="vertical" :key="index">{{ vertical }}</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="4" md6 sm12 xs24>
        <h4 :class="radioHeading">Horizontal Position</h4>
        <vc-radio-group
          name="horizontals"
          :color="radiosColor"
          v-model="horizontal">
          <vc-radio v-for="(horizontal, index) in horizontals" :value="horizontal" :key="index">{{ horizontal }}</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="4" md6 sm12 xs24>
        <h4 :class="radioHeading">Color</h4>
        <vc-radio-group
          :color="radiosColor"
          name="colors"
          v-model="color">
          <vc-radio v-for="(color, index) in colors" :value="color" :key="index">{{ color }}</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="4" md6 sm12 xs24>
        <h4 :class="radioHeading">Close button color</h4>
        <vc-radio-group
          :color="radiosColor"
          name="button-color"
          v-model="buttonColor">
          <vc-radio v-for="(color, index) in buttonColors" :value="color" :key="index">{{ color }}</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="8" md24 sm24 xs24>
        <h4 :class="radioHeading">Close delay</h4>
        <vc-text
          type="number"
          v-model="delay"
          name="delay"
          :disabled="showButtonDisabled"
          icon-left="av_timer"
          :label="closeDelayLabel"
          :placeholder="closeDelayLabel"
          :color="radiosColor" />
        <vc-button
          block
          :disabled="showButtonDisabled"
          :color="radiosColor"
          @click="show()">Show Snackbar</vc-button>
      </vc-col>
    </vc-layout>
    <vc-snackbar
      @close="onClose($event)"
      ref="snackbar"
      :color="color"
      :delay="delay"
      :button-color="buttonColor"
      :vertical="vertical"
      :button-label="buttonLabel"
      :horizontal="horizontal"
      :z-index="1500"
      :dark="dark">{{ text }}</vc-snackbar>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'PageSnackbar',
  mixins: [
    methods
  ],
  computed: {
    text () {
      return `Color ${this.color}, ${this.buttonColor} close button, positioned ${this.vertical}-${this.horizontal}.`
    }
  },
  data () {
    return {
      title: null,
      description: null,
      dark: true,
      showButtonDisabled: false,
      color: 'black',
      radioHeading: ['subheading', 'font-grey', 'font-l-600'],
      closeDelayLabel: 'Snackbar close delay in milliseconds',
      buttonColor: 'primary',
      delay: 5000,
      vertical: 'bottom',
      horizontal: 'center',
      buttonLabel: 'Close',
      radiosColor: this.$store.getters.categoryColor,
      verticals: ['top', 'bottom'],
      horizontals: ['left', 'center', 'right'],
      colors: ['primary', 'warning', 'success', 'error', 'black'],
      buttonColors: ['primary', 'red', 'orange', 'deep-purple', 'green']
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    show () {
      this.$refs['snackbar'].visible = true
      this.showButtonDisabled = true
    },
    onClose ($event) {
      console.log('vc-snackbar:close', $event)
      this.showButtonDisabled = $event
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/snackbar.vue